var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.03168,
    height: 34.03125,
    viewBox: "0 0 34.03168 34.03125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.0174,34.03125c-.52734,0-1.04199-.20703-1.42578-.59082-.5127-.51172-.71094-1.25879-.52051-1.95703l2.26953-8.3291c.09277-.33887.27148-.64844.52051-.89648L23.28595,1.83984h0c2.45508-2.45312,6.44922-2.45312,8.9043,0,2.45508,2.45605,2.45508,6.4502.00098,8.90527L11.76447,31.16309c-.24707.24805-.55566.42676-.89355.51855l-8.32129,2.27734c-.17578.04883-.35449.07227-.53223.07227Zm4.0752-9.29883l-1.2002,4.40332,4.39844-1.2041L29.33869,7.89258c.88086-.88184.88086-2.31738-.00098-3.2002-.87991-.87988-2.31641-.88281-3.2002.00098L6.09259,24.73242Z",
    fill: "#333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.d7a3672cecf09905da9c23500586cf06.svg";
export { ForwardRef as ReactComponent };